// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cb14215d","732":"59d3bfee","977":"a6e5cba1"}[chunkId] + ".chunk.js";
};